import { hasProp } from "../../../helpers/Class";
import Country from "../Country";

class CarrierTax {
    constructor(tax = null) {
        this.id = !hasProp(tax, "id") ? undefined : tax.id;
        this.carrierId = !hasProp(tax, "carrierId") ? undefined : tax.carrierId;
        this.deliveryCountryId = !hasProp(tax, "deliveryCountryId") ? undefined : tax.deliveryCountryId;
        this.name = !hasProp(tax, "name") ? undefined : tax.name;
        this.percent = !hasProp(tax, "percent") ? undefined : tax.percent;
        this.country = !hasProp(tax, "country") ? new Country() : new Country(tax.country);
    }
}

export default CarrierTax;